//
// Carousel functions
//
import { Carousel } from "@fancyapps/ui";

export default class TestimonialCarousel {
    constructor() {

        // Initialise Carousel JS if present, else quit out now
        const carouselContainer = document.getElementById("js-testimonial-carousel");
        if (!carouselContainer) return;

        const carouselOptions = {
            transition: "slide",
            Navigation: {
                nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 23"><path fill="#838E49" fill-rule="evenodd" d="m34.015.738 9.546 9.546a1.5 1.5 0 0 1 0 2.12l-9.546 9.547a1.5 1.5 0 0 1-2.122-2.122l6.986-6.985H.5v-3h38.379L31.893 2.86A1.5 1.5 0 1 1 34.015.738Z" clip-rule="evenodd"/></svg>',
                prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 23"><path fill="#838E49" fill-rule="evenodd" d="M.44 12.405a1.5 1.5 0 0 1 0-2.121L9.984.738a1.5 1.5 0 1 1 2.122 2.12L5.12 9.845H43.5v3H5.121l6.986 6.985a1.5 1.5 0 0 1-2.122 2.122L.44 12.405Z" clip-rule="evenodd"/></svg>',
            },
         };

        new Carousel(carouselContainer, carouselOptions);

    }
}